<template>
    <div class="user_zl_phone_pop">
        <el-dialog title="修改手机号" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box"  v-loading="loading">
              <div class="form_flex">
                <div class="form_title">输入新手机号：</div>
                <div class="form_input1">
                    <input type="text" v-model="mobile" placeholder="输入新手机号">
                </div>
              </div>
              <div class="form_flex">
                <div class="form_title">验证码：</div>
                <div class="form_input2">
                    <input type="text" placeholder="输入验证码" v-model="code">
                    <div class="code_btns" @click="handle_code">{{code_text}}</div>
                </div>
              </div>
              <div class="form_btns">
                <div class="btns1" @click="handle_end">确认</div>
                <div class="btns2" @click="handle_clear">取消</div>
              </div>
            </div>
        </el-dialog>

       
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:false,//显示隐藏
          
            code_text:'获取验证码',
            codeShow: true,
            count: '',
            timer: null,
            mobile: "",  //手机号
            code:'',//验证码
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {

    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
       
        handle_open(){
            this.mobile=''  //手机号
            this.code=''  //验证码
            this.dialogVisible=true
        },
        handle_end(){
            this.$api("verifyCode", {
                mobile:this.mobile,
                code:this.code,
			}, "get").then((res) => {
                this.loading = false
                console.log('提交验证',res)
                if (res.code == 1) {
                   this.end_pphone()
                } else {
                    alertErr(res.msg)
                }
            });
        },
        end_pphone(){
            this.$api("bdPhone", {
                mobile:this.mobile,
			}, "get").then((res) => {
                this.loading = false
                console.log('修改手机号',res)
                if (res.code == 1) {
                    alertSucc('修改成功')
                    this.dialogVisible=false
                    this.$emit('get_user')
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_clear(){
            this.mobile=''
            this.code=''
            this.dialogVisible=false

        },
        handle_code(){
            var Reg = /^[1][123456789][0-9]{9}$/;
            // 正则验证
            if (Reg.test(this.mobile)) {
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.loading=true
                    this.count = TIME_COUNT;
                    this.codeShow = false;
                    this.loading=false
                    this.$api("send", {
                        mobile:this.mobile,
                    }, "get").then((res) => {
                        this.loading = false
                        console.log('提交用户信息',res)
                        if (res.code == 1) {
                             alertSucc('验证码发送成功');
                               //下面接口调取
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= TIME_COUNT) {
                                    this.count--;
                                    this.code_text=this.count+'秒后重新发送'
                                } else {
                                    this.codeShow = true;
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    this.code_text='重新发送'
                                }
                            }, 1000)
                        
                        } else {
                            alertErr(res.msg)
                        }
                    });
                  
                }
             
                
            } else {
                alertErr('手机号码格式不正确');
            }

        },



    },

}
</script>
<style scoped lang="less">
.user_zl_phone_pop {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 596px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                    .form_flex{
                        display: flex;
                        align-items: center;
                        margin-bottom: 24px;
                        .form_title{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            padding-right: 10px;
                            width: 110px;
                            flex-shrink: 0;
                            text-align: right;
                        }
                        .form_input1{
                            width: 400px;
                            height: 50px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #EEEEEE;
                            display: flex;
                            align-items: center;
                            padding: 14px 16px;

                            input{
                                flex:1;

                            }
                            
                        }
                        .form_input2{
                            width: 400px;
                            height: 50px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #EEEEEE;
                            display: flex;
                            align-items: center;
                            padding: 14px 16px;
                            input{
                                flex:1;
                                padding-right: 16px;
                            }
                            .code_btns{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                                cursor: pointer;
                            } 
                        }
                    }
                    .form_btns{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 40px;
                        .btns1{
                            width: 104px;
                            height: 40px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            line-height: 40px;
                            text-align: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                        }
                        .btns2{
                            width: 104px;
                            height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            margin-left: 20px;
                        }
                    }
                }
               
            }
        }
    }
}
</style>